import React, { ReactNode, useState } from "react";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
// import Link from '@mui/material/Link';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import ListItem from "@mui/material/ListItem";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Button from "@mui/material/Button";
import Fade from '@mui/material/Fade';

import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LogoutIcon from '@mui/icons-material/Logout';

import Stack from '@mui/material/Stack';

import { menuNavigation } from "../../resources/menu";
import { hasChildren } from "../../utils/common";

import { Link } from "react-router-dom";

import Avatar from '@mui/material/Avatar';

import { googleLogout } from '@react-oauth/google';

import { Notification } from "../../components/notification/notification";

interface Props {
    children: ReactNode;
}

// Sidebar menu
const _MenuItem = (item: any) => {
    const Component = hasChildren(item.item) ? MultiLevel : SingleLevel;
    return <Component item={item.item} />;
};

const SingleLevel = (props: any) => {
    return (
        <ListItem component={Link} to={props.item.to}>
            <ListItemIcon>{props.item.icon}</ListItemIcon>
            <ListItemText primary={props.item.title} />
        </ListItem>
    )
};

const MultiLevel = (item: any) => {
    const { items: children } = item.item;
    const [open, setOpen] = React.useState(true);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    return (
        <React.Fragment>
            <ListItem onClick={handleClick}>
                <ListItemIcon>{item.item.icon}</ListItemIcon>
                <ListItemText primary={item.item.title} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {children.map((child: any, key: any) => (
                        <_MenuItem key={key} item={child} />
                    ))}
                </List>
            </Collapse>
        </React.Fragment>
    );
};

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      {/* <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '} */}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth: number = 260;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#00275A",
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      backgroundColor: "#E7F5F6",
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Layout({ children }: Props) {
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const logOut = () => {
    googleLogout();
    localStorage.clear();
    window.location.reload();
  };

  const [profile, setProfile] = useState<any>({});

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openProfileAction = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(
    () => {
      const loggedInUser = localStorage.getItem("user");
  
      if (loggedInUser) {
        const foundUser = JSON.parse(loggedInUser);
        setProfile(foundUser);
        // console.log('PROFILE SIDEBAR: ', foundUser);
      }
  },[]);
  
  return (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        {/* <AppBar
        position="fixed"
        sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Permanent drawer
          </Typography>
        </Toolbar>
      </AppBar> */}
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="permanent"
        anchor="left"
       >
        <Box sx={{padding: "10px", textAlign: "center", marginTop: "25px"}}>
          <img src="/global/images/sk-logo-trans.png" alt="" style={{ width: '85%'}} />
        </Box>
        
        <Box sx={{height: "100%"}}>
          <Stack 
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            sx={{height: "100%"}}
            >
            <Box>
              <List component="nav">
                {menuNavigation.map((item, key) => {
                    return <_MenuItem key={key} item={item} />
                })}
              </List>
            </Box>
            
            <Box display="flex"
              justifyContent="center"
              alignItems="flex-end" 
              sx={{marginTop: "30px !important", height: "100%", width: "100%"}}>
              <Box display="flex" alignItems="flex-start" sx={{paddingLeft: "5px", paddingRight: "5px", borderTop: "1px solid black", width: "100%"}}>
                
                {/* <Box >
                  <Avatar alt={profile.name} src={profile.picture} sx={{ width: 72, height: 72 }} />
                </Box>
                <Box 
                  sx={{marginTop: "10px !important"}}>
                  <Typography variant="subtitle1" color="text.secondary">
                    {profile.name}
                  </Typography>
                </Box>
                <Box 
                
                  sx={{marginTop: "30px !important"}}>
                  <Button size="small" variant="outlined" startIcon={<LogoutIcon />} onClick={logOut}>Logout</Button>
                </Box> */}

                <List component="nav" sx={{ width: '100%' }}>
                  <ListItem button sx={{paddingLeft: "10px", paddingRight: "10px"}}
                  secondaryAction={
                    <IconButton edge="end" aria-label="more">
                      <MoreVertIcon />
                    </IconButton>
                  }
                  onClick={handleClick}
                  >
                    <ListItemAvatar>
                      <Avatar alt={profile.name} src={profile.picture} sx={{ width: 48, height: 48 }} />
                    </ListItemAvatar>
                    <ListItemText sx={{marginLeft: "0px"}}
                      primary={
                        <Typography
                            sx={{ overflow: 'hidden', textOverflow: "ellipsis", marginRight: "15px" }}>
                             {profile.name}
                          </Typography>
                        }
                      /* secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {profile.email}
                          </Typography>
                        </React.Fragment>
                      } */
                    />
                  </ListItem>
                </List>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={openProfileAction}
                  onClose={handleClose}
                  TransitionComponent={Fade}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  MenuListProps={{
                    'aria-labelledby': 'fade-button',
                    sx: { width: anchorEl && anchorEl.offsetWidth},
                 }}
                 sx={{ marginBottom: "20px", left: "-10px", top: "-70px" }}
                >
                  <MenuItem onClick={handleClose}>Settings</MenuItem>
                  <MenuItem onClick={logOut}>Logout</MenuItem>
                </Menu>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Drawer>

      <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
         
          <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
          {children}
          </Container>
        </Box>
        {
          // Add the notification component here
          <Notification />
        }
      </Box>
  );
}